import { useEffect, useState } from "react";
import { Grid } from "@mui/material";

import { FormTitle, DatePickerField, Text, SelectField } from "ui-components/Form";
import MDBox from "components/MDBox";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";
import { useZoneOptionsQuery } from "hooks/useZoneQuery";
import { useLocationOptionsQuery } from "hooks/useLocationQuery";
import { ReadOnlyTextField } from "ui-components/Form";
import { numberValidation } from "layouts/views/common/validation";
import { conditionOptions } from "layouts/views/common/options";
function COReceivingDetail({
  detailRender,
  values,
  control,
  errors,
  setValue,
  getValues,
  mode = "ADD",
}) {
  const [whOptions, setWhOptions] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [locOptions, setLocOptions] = useState([]);
  const [newItem, status, mlnCtrl, manualLotCtrl, manDateCtrl, expiryDateCtrl] = getValues([
    "newItem",
    "status",
    "mlnCtrl",
    "manualLotCtrl",
    "manDateCtrl",
    "expiryDateCtrl",
  ]);
  const { customerCode, qtyReceived, recvWh, recvZone } = values;
  // useEffect(() => {
  //   setValue("quantity", qtyReceived);
  // }, [qtyReceived]);

  useCustWhOptionsQuery({
    customerCode,
    onSuccess: (data) => setWhOptions(data.data.data),
  });
  useZoneOptionsQuery({
    whCode: recvWh,
    zoneType: "return",
    enabled: Boolean(recvWh && status === "Open"),
    onSuccess: (data) => setZoneOptions(data.data.data),
  });
  useLocationOptionsQuery({
    whCode: recvWh,
    zoneID: recvZone,
    enabled: Boolean(recvWh && recvZone && status === "Open"),
    onSuccess: (data) => setLocOptions(data.data.data),
  });
  const onZoneChange = (e, option) => {
    setLocOptions([]);
    setValue("recvZone", option);
    setValue("recvLocation", null);
  };
  const onWarehouseChange = (e, option) => {
    setZoneOptions([]);
    setLocOptions([]);
    setValue("recvWh", option);
    setValue("recvZone", null);
    setValue("recvLocation", null);
  };
  const onQtyChange = (e) => {
    const { value } = e.target;
    const qty = numberValidation(value);
    setValue("qtyReceived", qty, { shouldDirty: true });
    setValue("quantity", qty);
  };
  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = size ? size : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      // ...(mode === "EDIT" &&
      //   newItem === false &&
      //   editable === false && { disabled: true, type: "text" }),
      // ...(mode === "EDIT" && status !== "Open" && { disabled: true }),
      ...(status !== "Open" && { type: "readonly" }),
      ...(data.name === "manufacturingDate" && Boolean(manDateCtrl) && { required: true }),
      ...(data.name === "mln" && Boolean(mlnCtrl) && { required: true }),
      ...(data.name === "manualLot" && Boolean(manualLotCtrl) && { required: true }),
      ...(data.name === "expiryDate" && Boolean(expiryDateCtrl) && { required: true }),
      ...(data.name === "qtyReceived" && { onChange: onQtyChange }),
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "readonly":
        renderField = <ReadOnlyTextField field={fieldProps} />;
        break;
      case "select":
        let options = [];
        let onChange = null;
        switch (data.name) {
          case "recvWh":
            options = whOptions;
            onChange = onWarehouseChange;
            break;
          case "recvZone":
            options = zoneOptions;
            onChange = onZoneChange;
            break;
          case "recvLocation":
            options = locOptions;
            break;
          case "condition":
            options = conditionOptions;
            break;
        }
        renderField = <SelectField field={fieldProps} options={options} onChange={onChange} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit CO Receiving Detail" : "Add CO Receiving Detail"} />
      <MDBox mt={1.625}>
        {detailRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default COReceivingDetail;
